import DeleteIcon from "@mui/icons-material/Delete";
import { Chip, IconButton, Paper } from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import * as React from "react";
import { Config } from "../../../config/config";
import { getGlobalVar, Helpers } from "../../../utils/helpers";
import { PopupMessage } from "../../../utils/message";
import { AddPlayerDailyJob } from "./addDailyJob";

interface Props {
    playerId: string;
    activeEnv: any;
    heroesConfig: any;
    classes?: any;
    form?: any;
    playerData: any;
    fetchData(): void;
    changeProgress(e, type, id, jobType): void;
    deleteJob(type, id, jobType): void;
    data: any;
    config: any;
}

export class PlayerDailyJobs extends React.Component<Props, any> {
    constructor(props) {
        super(props);
    }

    deleteDailyJob = async (dailyJobId, type) => {
        try {
            if (confirm("Are you sure?")) {
                const response = await axios.delete(`${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/daily_job/${dailyJobId}/${type}`, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                        env: this.props.activeEnv,
                    }
                });

                this.props.deleteJob("daily_jobs", dailyJobId, type);

                this.setState({ loaded: true });
            }
        } catch (error) {
            PopupMessage.error("Couldn't delete contract");
        }
    }

    saveProgress = async (e, dailyJobId, type) => {
        try {
            await axios.put(`${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/daily_job/${dailyJobId}/${type}`, {
                progress: e.target.value,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });
        } catch (error) {
            PopupMessage.error("Something went wrong");
        }
    }

    displayChallenge = (item: any, config: any, type: "ranked" | "ruby") => {
        const dailyJobConfig = config.dailyJobs.find(job =>
            job.key === String(item.key).trim() &&
            job.hqLevel === parseInt(item.hqLevel, 10) &&
            job.difficulty === String(item.difficulty).trim(),
        );
        return <Paper className={`dailyJobs--item ${!dailyJobConfig ? "no-config" : ""}`} key={item.id} elevation={0}>
            <div style={{ padding: "15px 10px", margin: "10px", overflow: "hidden" }}>
                <div style={{ float: "left", width: 100 }}>
                    <Chip label={item.difficulty.toUpperCase()} style={{paddingRight: 5}} />
                </div>
                <div style={{ float: "left" }}>
                    <div>[<b>{item.key}</b>] {Helpers.getLocalizationName(`DJOB_TITLE_${item.key}`)}</div>
                    <div>{Helpers.getLocalizationName(`DJOB_DESC_${item.key}`).replace("{0}", (dailyJobConfig?.goal || 0))}</div>
                </div>
                <div style={{ float: "right", paddingRight: 15, paddingTop: 5 }}>
                    <div style={{ display: "inline-block", paddingTop: 5 }}>
                        <span>
                            {Helpers.conditionPrint(this.props.playerData.is_online, <input
                                type="number"
                                value={item.progress}
                                style={{ width: (dailyJobConfig?.goal || 0) < 1000 ? 45 : 55, marginRight: 5 }}
                                max={dailyJobConfig?.goal + 1 || 0}
                                min={0}
                                className="simple-input"
                                onChange={(e) => this.props.changeProgress(e, "daily_jobs", item.id, type)}
                                onBlur={(e) => this.saveProgress(e, item.id, type)}
                            />, item.progress)}
                        </span>
                        <span>/ {dailyJobConfig?.goal || 0}</span>
                    </div>
                    <div style={{ paddingLeft: 25, display: "inline-block" }}>
                        {Helpers.conditionPrint(this.props.playerData.is_online,
                        <IconButton aria-label="delete" size="small" onClick={() => this.deleteDailyJob(item.id, type)}>
                            <DeleteIcon />
                        </IconButton>, "")}
                    </div>
                </div>
            </div>
        </Paper>;
    } 

    displayContracts = () => {
        const rankedChallenges = this.props.data.dailyJobs;
        const rubyBattleJobs = this.props.data.rubyBattleJobs;
        

        return <React.Fragment>
            <div style={{ borderWidth: 1, borderRadius: 5 }}>
                <Chip label={"RANKED CHALLENGES"}/>
                {rankedChallenges.map(item => this.displayChallenge(item, this.props.config, "ranked"))}
                {rankedChallenges.length === 0 && <Alert severity="info">
                    No ranked daily challenges
                </Alert>}
            </div>
            <div style={{ borderWidth: 1, borderRadius: 5 }}>
                <Chip label={"RUBY CHALLENGES"}/>
                {rubyBattleJobs.map(item => this.displayChallenge(item, this.props.config, "ruby"))}
                {rubyBattleJobs.length === 0 && <Alert severity="info">
                    No ruby daily challenges
                </Alert>}
                
            </div>
        </React.Fragment>;
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ display: "inline: block" }}>
                    <div style={{ float: "left" }}></div>
                    <div style={{ float: "right" }}>
                        <AddPlayerDailyJob {...this.props} refreshData={this.props.fetchData}/>
                    </div>
                </div>

                <div style={{ marginTop: "4em", clear: "both" }}>
                    {this.displayContracts()}
                </div>
            </React.Fragment>
        );
    }
}